export default {
  name: 'projectItem',
  props: {
    project: {
      type: Object,
      default() {
        return {}
      },
    },
    displayEditButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      numberDate: 0,
      daysAll: 45,
    }
  },
  methods: {
    goToDetails() {
      window.location.href = '/greenfund/' + this.project._id
    },
    getDays(updated) {
      var date = new Date(),
          now = date.getTime()
      return (this.daysAll - Math.round((now - new Date(updated).getTime())/(1000*60*60*24)))
    },
  },
  async created() {
    this.$nextTick().then(() => this.refreshDisplayProjects())

    jQuery(document).ready(function($) {
      var items = document.querySelectorAll(
        '.item-block .cmb-txt h4, .item-block .cmb-txt div'
      )

      for (var i = 0; i < items.length; i++) {
        $clamp(items[i], { clamp: 3 })
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/GreenFund/FundProjectItem/ProjectItem.component.js